/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountDto } from '../models/AccountDto';
import type { PicodedAccountDTO } from '../models/PicodedAccountDTO';
import { request as __request } from '@openapi/request';

export class AccountService {

    /**
     * @returns any
     * @throws ApiError
     */
    public static async getSupervisorList(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/live/api/account/supervisorlist`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static async verifyToken(
        requestBody: AccountDto,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/live/api/account/verify-token`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static async genToken(
        requestBody: AccountDto,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/live/api/account/request-reset-password`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static async generateOtp(
        requestBody: AccountDto,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/live/api/account/generate-otp`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static async resetPasswordWithToken(
        requestBody: AccountDto,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/live/api/account/reset-password`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param directorOid
     * @returns PicodedAccountDTO
     * @throws ApiError
     */
    public static async getDirectorSupervisorList(
        directorOid: string,
    ): Promise<Array<PicodedAccountDTO>> {
        const result = await __request({
            method: 'GET',
            path: `/live/api/account/${directorOid}/director-supervisorlist`,
        });
        return result.body;
    }

}